import {
  Component,
  computed,
  inject,
  signal,
  WritableSignal,
} from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { IconsModule } from '@boldpenguin/emperor-icons';
import {
  EmperorButtonModule,
  EmperorSpinnerModule,
  EmperorUIButtonTypes,
} from '@boldpenguin/emperor-presentational';
import {
  ISmartUploadProcess,
  SmartUploadProcessStatus,
} from 'src/app/features/quotes/components/document-upload-submission-link-dialog/submission-link-upload.models';
import { SubmissionLinkUploadService } from 'src/app/features/quotes/components/document-upload-submission-link-dialog/submission-link-upload.service';
import { ProcessBarComponent } from '../process-bar/process-bar.component';
import * as QuotesActions from 'src/app/features/quotes/store/quotes.actions';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-in-progress-panel',
  templateUrl: './in-progress-panel.component.html',
  styleUrls: ['./in-progress-panel.component.scss'],
  imports: [
    MatExpansionModule,
    MatIconModule,
    EmperorSpinnerModule,
    EmperorButtonModule,
    IconsModule,
    ProcessBarComponent,
  ],
})
export class InProgressPanelComponent {
  isExpanded: WritableSignal<boolean> = signal(true);
  private _submissionLinkUploadService = inject(SubmissionLinkUploadService);
  private _router = inject(Router);
  private store = inject(Store);
  readonly smartProcesses = computed(() =>
    [...this._submissionLinkUploadService.smartUploadProcesses()].reverse(),
  );
  readonly incompleteProcessLength = computed(() => {
    const processes = this.smartProcesses();
    return processes.filter(
      (process) =>
        process.status !== SmartUploadProcessStatus.Completed &&
        process.status !== SmartUploadProcessStatus.Failed,
    ).length;
  });
  readonly EmperorUIButtonTypes = EmperorUIButtonTypes;
  readonly SmartUploadProcessStatus = SmartUploadProcessStatus;

  removeProcess(uploadId: string) {
    this._submissionLinkUploadService.smartUploadProcesses.update((processes) =>
      processes.filter((process) => process.upload_id !== uploadId),
    );
  }

  navigateToAppForm(process: ISmartUploadProcess) {
    if (!process.application_id) return;
    this._router.navigate(['/quotes/form/', process.application_id]);
    this.removeProcess(process.upload_id);
  }

  openSmartUploadDialog(uploadId: string) {
    this.removeProcess(uploadId);
    this.store.dispatch(QuotesActions.TriggerApplicationSmartUploadDialog());
  }
}
